export const CODESETS_BEGIN_WAIT = "CODESETS_BEGIN_WAIT";
export const CODESETS_END_WAIT = "CODESETS_END_WAIT";

export const CODESETS_UPDATE_CODESETS = "CODESETS_UPDATE_CODESETS";
export const CODESETS_UPDATE_CODES = "CODESETS_UPDATE_CODES";
export const CODESETS_ADD_NOTIFICATION = "CODESETS_ADD_NOTIFICATION";

export const CODESETS_FETCH_EXPORT_REQUEST = "CODESETS_FETCH_EXPORT_REQUEST";
export const CODESETS_EXPORT_SUCCESS = "CODESETS_EXPORT_SUCCESS";
export const CODESETS_EXPORT_FAILURE = "CODESETS_EXPORT_FAILURE";
export const CODESETS_CLEAR_EXPORT_STATE = "CODESETS_CLEAR_EXPORT_STATE";

export const CODESETS_MARK_DELETED_CODE = "CODESETS_MARK_DELETED_CODE";
